/* EVIAL — блок покупки на карточке товара по утверждённому макету.
   Разметку приложения Shopify Subscriptions не переписываем: она остаётся в DOM
   и продолжает управлять полем selling_plan, но визуально прячется, а вместо неё
   рисуется свой блок, который проксирует клики на скрытые радиокнопки.
   Полный откат — убрать подключение этого файла и блок
   "EVIAL — product buy block" в base.css. */
(function () {
  'use strict';

  var SUB_DEFAULT = true; // подписка выбрана по умолчанию; false — вернуть разовую
  var userPickedOnce = false;
  var subDefaultDone = false;
  var subTries = 0;

  var ICON = {
    ship: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>',
    pause: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="8" width="2.5" height="8" rx="1"/><rect x="14" y="8" width="2.5" height="8" rx="1"/><circle cx="12" cy="12" r="9"/></svg>',
    save: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 15l5-5 3 3 6-7"/><path d="M15 6h4v4"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 2.5v5c0 5-3 8.2-7 9.5-4-1.3-7-4.5-7-9.5v-5z"/><path d="M9 12l2.2 2.2L15 10"/></svg>',
    norenew: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 11a8 8 0 0 0-13.3-5.9"/><path d="M4 13a8 8 0 0 0 13.3 5.9"/><path d="M7 3v3.5H3.5"/><path d="M17 21v-3.5h3.5"/><path d="M4 4l16 16"/></svg>',
    lab: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h9l4 4v14H6z"/><path d="M15 3v4h4"/><path d="M9.5 14l2 2 3.5-4"/></svg>'
  };

  var PERKS = [
    [ICON.ship, 'Every order ships free'],
    [ICON.pause, 'Pause or cancel anytime'],
    [ICON.save, '20% off every delivery']
  ];

  var TRUST = [
    ['<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0875 2.20592L10.5518 0.156677C9.97805 -0.0522258 9.042 -0.0522258 8.46829 0.156677L2.93249 2.20592C1.8656 2.60383 1 3.83735 1 4.96145V13.0191C1 13.8249 1.53345 14.8893 2.18768 15.3668L7.72347 19.4554C8.69978 20.1815 10.3001 20.1815 11.2764 19.4554L16.8122 15.3668C17.4665 14.8794 17.9999 13.8249 17.9999 13.0191V4.96145C18.01 3.83735 17.1444 2.60383 16.0875 2.20592ZM13.0076 7.77667L8.67965 12.0542C8.52868 12.2034 8.33744 12.2731 8.1462 12.2731C7.95497 12.2731 7.76373 12.2034 7.61275 12.0542L6.00234 10.4427C5.86195 10.3023 5.78322 10.1128 5.78322 9.91544C5.78322 9.71805 5.86195 9.52861 6.00234 9.38821C6.29423 9.09973 6.77735 9.09973 7.06924 9.38821L8.15627 10.4626L11.9508 6.71226C12.2427 6.42377 12.7258 6.42377 13.0177 6.71226C13.3096 7.00075 13.3096 7.48819 13.0076 7.77667Z" fill="url(#paint0_linear_740_9357)"/><defs><linearGradient id="paint0_linear_740_9357" x1="1.83607" y1="-1.23744e-06" x2="20.0901" y2="3.17459" gradientUnits="userSpaceOnUse"><stop stop-color="#007D54"/><stop offset="1" stop-color="#003C28"/></linearGradient></defs></svg>', '30-day guarantee'],
    ['<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_740_9365)"><path d="M0.904469 11.1594C0.648203 11.1594 0.433544 11.0757 0.260489 10.9082C0.0874348 10.7408 0.000606096 10.5329 3.11885e-06 10.2844C-0.000599858 10.0359 0.0862288 9.82821 0.260489 9.66138C0.43475 9.49454 0.649409 9.41054 0.904469 9.40937H4.0701C4.32636 9.40937 4.54132 9.49337 4.71498 9.66138C4.88864 9.82937 4.97517 10.037 4.97456 10.2844C4.97396 10.5317 4.88713 10.7397 4.71408 10.9082C4.54102 11.0768 4.32636 11.1605 4.0701 11.1594H0.904469ZM3.73092 16.2344C3.20332 15.724 2.93952 15.1042 2.93952 14.375H1.80893C1.50745 14.375 1.26626 14.2656 1.08536 14.0469C0.904469 13.8281 0.851708 13.5802 0.92708 13.3031L1.13059 12.4719H3.95704C4.59017 12.4719 5.12531 12.2604 5.56247 11.8375C5.99963 11.4146 6.2182 10.8969 6.2182 10.2844C6.2182 10.0948 6.19559 9.91979 6.15037 9.75938C6.10515 9.59896 6.04485 9.43854 5.96948 9.27813H6.82872C7.46184 9.27813 7.99699 9.06667 8.43414 8.64375C8.8713 8.22083 9.08988 7.70312 9.08988 7.09063C9.08988 6.47813 8.8713 5.96042 8.43414 5.5375C7.99699 5.11458 7.46184 4.90313 6.82872 4.90313H3.39175L3.52742 4.37812C3.61787 3.96979 3.82529 3.63817 4.14969 3.38325C4.47409 3.12833 4.85457 3.00058 5.29113 3H14.4715C14.7729 3 15.0141 3.10938 15.195 3.32812C15.3759 3.54688 15.4287 3.79479 15.3533 4.07187L14.7654 6.5H16.5065C16.7929 6.5 17.0643 6.56213 17.3205 6.68638C17.5768 6.81063 17.7878 6.98183 17.9536 7.2L19.6495 9.36562C19.8153 9.56979 19.9209 9.79233 19.9661 10.0332C20.0113 10.2742 20.0113 10.5183 19.9661 10.7656L19.3556 13.675C19.3103 13.8792 19.2048 14.0469 19.039 14.1781C18.8732 14.3094 18.6848 14.375 18.4737 14.375H17.411C17.411 15.1042 17.1472 15.724 16.6196 16.2344C16.092 16.7448 15.4513 17 14.6976 17C13.9438 17 13.3032 16.7448 12.7756 16.2344C12.248 15.724 11.9842 15.1042 11.9842 14.375H8.36631C8.36631 15.1042 8.10251 15.724 7.5749 16.2344C7.0473 16.7448 6.40663 17 5.65291 17C4.89919 17 4.25853 16.7448 3.73092 16.2344ZM2.7134 7.96563C2.45713 7.96563 2.24247 7.88163 2.06942 7.71362C1.89637 7.54563 1.80954 7.33796 1.80893 7.09063C1.80833 6.84329 1.89516 6.63562 2.06942 6.46762C2.24368 6.29962 2.45834 6.21563 2.7134 6.21563H6.78349C7.03976 6.21563 7.25472 6.29962 7.42838 6.46762C7.60204 6.63562 7.68856 6.84329 7.68796 7.09063C7.68736 7.33796 7.60053 7.54592 7.42747 7.7145C7.25442 7.88308 7.03976 7.96679 6.78349 7.96563H2.7134ZM5.65291 15.25C5.90918 15.25 6.12414 15.166 6.2978 14.998C6.47145 14.83 6.55798 14.6223 6.55738 14.375C6.55678 14.1277 6.46995 13.92 6.29689 13.752C6.12384 13.584 5.90918 13.5 5.65291 13.5C5.39665 13.5 5.18199 13.584 5.00893 13.752C4.83588 13.92 4.74905 14.1277 4.74845 14.375C4.74784 14.6223 4.83467 14.8303 5.00893 14.9989C5.18319 15.1675 5.39785 15.2512 5.65291 15.25ZM14.6976 15.25C14.9538 15.25 15.1688 15.166 15.3425 14.998C15.5161 14.83 15.6026 14.6223 15.602 14.375C15.6014 14.1277 15.5146 13.92 15.3415 13.752C15.1685 13.584 14.9538 13.5 14.6976 13.5C14.4413 13.5 14.2266 13.584 14.0536 13.752C13.8805 13.92 13.7937 14.1277 13.7931 14.375C13.7925 14.6223 13.8793 14.8303 14.0536 14.9989C14.2279 15.1675 14.4425 15.2512 14.6976 15.25ZM13.7253 10.875H18.0893L18.1798 10.4156L16.5065 8.25H14.3584L13.7253 10.875Z" fill="url(#paint0_linear_740_9365)"/></g><defs><linearGradient id="paint0_linear_740_9365" x1="0.983611" y1="3" x2="21.367" y2="8.95784" gradientUnits="userSpaceOnUse"><stop stop-color="#007D54"/><stop offset="1" stop-color="#003C28"/></linearGradient><clipPath id="clip0_740_9365"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>', 'Ships next business day'],
    ['<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.125 0C7.62772 0 7.15081 0.197544 6.79917 0.549175C6.44754 0.900805 6.25 1.37772 6.25 1.875V3.125C6.25 3.62228 6.44754 4.09919 6.79917 4.45083C7.15081 4.80246 7.62772 5 8.125 5H11.875C12.3723 5 12.8492 4.80246 13.2008 4.45083C13.5525 4.09919 13.75 3.62228 13.75 3.125V1.875C13.75 1.37772 13.5525 0.900805 13.2008 0.549175C12.8492 0.197544 12.3723 0 11.875 0L8.125 0ZM11.875 1.25C12.0408 1.25 12.1997 1.31585 12.3169 1.43306C12.4342 1.55027 12.5 1.70924 12.5 1.875V3.125C12.5 3.29076 12.4342 3.44973 12.3169 3.56694C12.1997 3.68415 12.0408 3.75 11.875 3.75H8.125C7.95924 3.75 7.80027 3.68415 7.68306 3.56694C7.56585 3.44973 7.5 3.29076 7.5 3.125V1.875C7.5 1.70924 7.56585 1.55027 7.68306 1.43306C7.80027 1.31585 7.95924 1.25 8.125 1.25H11.875Z" fill="url(#paint0_linear_740_9359)"/><path d="M5 1.875H3.75C3.08696 1.875 2.45107 2.13839 1.98223 2.60723C1.51339 3.07607 1.25 3.71196 1.25 4.375V17.5C1.25 18.163 1.51339 18.7989 1.98223 19.2678C2.45107 19.7366 3.08696 20 3.75 20H16.25C16.913 20 17.5489 19.7366 18.0178 19.2678C18.4866 18.7989 18.75 18.163 18.75 17.5V4.375C18.75 3.71196 18.4866 3.07607 18.0178 2.60723C17.5489 2.13839 16.913 1.875 16.25 1.875H15V3.125C15 3.53538 14.9192 3.94174 14.7621 4.32089C14.6051 4.70003 14.3749 5.04453 14.0847 5.33471C13.7945 5.62489 13.45 5.85508 13.0709 6.01212C12.6917 6.16917 12.2854 6.25 11.875 6.25H8.125C7.2962 6.25 6.50134 5.92076 5.91529 5.33471C5.32924 4.74866 5 3.9538 5 3.125V1.875ZM13.5675 11.0675L9.8175 14.8175C9.75944 14.8757 9.69047 14.9219 9.61454 14.9534C9.53861 14.9849 9.45721 15.0011 9.375 15.0011C9.29279 15.0011 9.21139 14.9849 9.13546 14.9534C9.05953 14.9219 8.99056 14.8757 8.9325 14.8175L7.0575 12.9425C6.94014 12.8251 6.87421 12.666 6.87421 12.5C6.87421 12.334 6.94014 12.1749 7.0575 12.0575C7.17486 11.9401 7.33403 11.8742 7.5 11.8742C7.66597 11.8742 7.82514 11.9401 7.9425 12.0575L9.375 13.4913L12.6825 10.1825C12.7999 10.0651 12.959 9.99921 13.125 9.99921C13.291 9.99921 13.4501 10.0651 13.5675 10.1825C13.6849 10.2999 13.7508 10.459 13.7508 10.625C13.7508 10.791 13.6849 10.9501 13.5675 11.0675Z" fill="url(#paint1_linear_740_9359)"/><defs><linearGradient id="paint0_linear_740_9359" x1="6.61885" y1="-3.09361e-07" x2="14.2015" y2="2.32713" gradientUnits="userSpaceOnUse"><stop stop-color="#007D54"/><stop offset="1" stop-color="#003C28"/></linearGradient><linearGradient id="paint1_linear_740_9359" x1="2.11066" y1="1.875" x2="20.7428" y2="5.55571" gradientUnits="userSpaceOnUse"><stop stop-color="#007D54"/><stop offset="1" stop-color="#003C28"/></linearGradient></defs></svg>', 'Third-party tested']
  ];

  function money(n) {
    return '$' + n.toFixed(2);
  }

  function toNumber(text) {
    var m = String(text || '').replace(/,/g, '').match(/([\d]+\.?\d*)/);
    return m ? parseFloat(m[1]) : NaN;
  }

  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  function root() {
    return document.querySelector('.product-details');
  }

  function visibleSubBlock(r) {
    var all = r.querySelectorAll('.shopify_subscriptions_app_block');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].classList.contains('shopify_subscriptions_app_block--hidden')) return all[i];
    }
    return all[0] || null;
  }

  function readVariants(r) {
    var labels = [].slice.call(r.querySelectorAll('.variant-option__button-label'));
    var blocks = [].slice.call(r.querySelectorAll('.shopify_subscriptions_app_block'));
    return labels.map(function (label, i) {
      var textNode = label.querySelector('.variant-option__button-label__text');
      var servings = parseInt((textNode ? textNode.textContent : '').trim(), 10);
      var block = blocks[i];
      var otp = NaN;
      var sub = NaN;
      if (block) {
        var tabs = block.querySelectorAll('.tab_label');
        if (tabs[0]) otp = toNumber((tabs[0].querySelector('.price') || {}).textContent);
        if (tabs[1]) sub = toNumber((tabs[1].querySelector('.price') || {}).textContent);
      }
      return {
        label: label,
        input: label.querySelector('input'),
        block: block,
        servings: servings,
        grams: servings ? servings * 5 : 0,
        otp: otp,
        sub: sub
      };
    });
  }

  function currentVariant(variants) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].input && variants[i].input.checked) return variants[i];
    }
    return variants[0];
  }

  /* ---------- карточки размеров ---------- */
  function addSizeMeta(r, variants) {
    var legend = r.querySelector('.variant-option--buttons > legend');
    if (legend && legend.textContent.trim() !== 'Select your size') {
      legend.textContent = 'Select your size';
    }

    var best = null;
    variants.forEach(function (v) {
      if (!v.servings || isNaN(v.otp)) return;
      var per = (isNaN(v.sub) ? v.otp : v.sub) / v.servings;
      if (!best || per < best.per) best = { v: v, per: per };
    });

    variants.forEach(function (v, i) {
      if (!v.servings || isNaN(v.otp)) return;
      var text = v.label.querySelector('.variant-option__button-label__text');
      if (text && text.textContent.trim().indexOf('•') === -1) {
        text.innerHTML = '<span class="ev-pdp__servings">' + text.textContent.trim() + '</span><span class="ev-pdp__dotsep">•</span><span class="ev-pdp__grams">' + v.grams.toLocaleString() + ' g</span>';
      }
      var compare = !isNaN(v.sub) && v.sub < v.otp ? '<s>' + money(v.otp) + '</s>' : '';
      var price = !isNaN(v.sub) && v.sub < v.otp ? v.sub : v.otp;
      var save = !isNaN(v.sub) && v.sub < v.otp ? '<span class="ev-pdp__discount">20% off</span><span class="ev-pdp__save">You save ' + money(v.otp - v.sub) + '</span>' : '';
      var imageSrc = (document.querySelector('.ev-pdp__double-image-src') || {}).dataset?.src;
      var image = i === 1 && imageSrc ? '<img class="ev-pdp__variant-image" src="' + imageSrc + '" alt="" width="64" height="64" loading="lazy">' : '';
      var html =
        '<span class="ev-pdp__per">' + money(price / v.servings) + ' / serving</span>' +
        '<span class="ev-pdp__price">' + compare + '<b>' + money(price) + '</b></span>' +
        save + image;
      var meta = v.label.querySelector('.ev-pdp__sizemeta');
      if (!meta) {
        meta = el('<span class="ev-pdp__sizemeta"></span>');
        v.label.appendChild(meta);
      }
      if (meta.innerHTML !== html) meta.innerHTML = html;

      var wantsBadge = best && best.v === v && variants.length > 1;
      var badge = v.label.querySelector('.ev-pdp__best');
      if (wantsBadge && !badge) v.label.appendChild(el('<span class="ev-pdp__best">Most popular</span>'));
      if (!wantsBadge && badge) badge.remove();
    });
  }

  /* ---------- свой блок «How would you like it» ---------- */
  function planLabel(input) {
    var li = input.closest('li') || input.parentElement;
    var text = li ? li.textContent : '';
    var m = text.match(/every\s+([^,]+)/i);
    return m ? 'Every ' + m[1].trim() : text.trim();
  }

  function planDays(input) {
    var li = input.closest('li') || input.parentElement;
    var m = String(li ? li.textContent : '').match(/every\s+(\d+)?\s*(week|month)/i);
    if (!m) return 0;
    var n = m[1] ? parseInt(m[1], 10) : 1;
    return m[2].toLowerCase() === 'week' ? n * 7 : n * 30;
  }

  function buildPanel(r) {
    var container = r.querySelector('.shopify_subscriptions_app_container');
    if (!container) return null;
    container.classList.add('ev-subs-native');

    var panel = r.querySelector('.ev-buy');
    if (panel) return panel;

    panel = el(
      '<div class="ev-buy">' +
        '<div class="ev-buy__eyebrow">How would you like it</div>' +
        '<div class="ev-buy__opts" role="radiogroup" aria-label="Purchase options">' +

          '<div class="ev-buy__opt ev-buy__opt--sub" data-mode="sub" role="radio" tabindex="0" aria-checked="false">' +
            '<span class="ev-buy__pop">Most popular</span>' +
            '<span class="ev-buy__dot"></span>' +
            '<div class="ev-buy__body">' +
              '<div class="ev-buy__top">' +
                '<div class="ev-buy__left">' +
                  '<div class="ev-buy__name">Subscribe &amp; save <span class="ev-buy__save">Save 20%</span></div>' +
                  '<div class="ev-buy__per" data-ev="subPer"></div>' +
                '</div>' +
                '<div class="ev-buy__price">' +
                  '<s data-ev="subWas"></s><b data-ev="subNow"></b>' +
                  '<div class="ev-buy__you">You save <span data-ev="subSave"></span></div>' +
                '</div>' +
              '</div>' +
              '<div class="ev-buy__fold">' +
                '<div class="ev-buy__cad" data-ev="cad"></div>' +
                '<div class="ev-buy__perks" data-ev="perks"></div>' +
                '<p class="ev-buy__policy">Auto-renews. Skip, pause or cancel anytime.</p>' +
              '</div>' +
            '</div>' +
          '</div>' +

          '<div class="ev-buy__opt ev-buy__opt--once" data-mode="once" role="radio" tabindex="0" aria-checked="false">' +
            '<span class="ev-buy__dot"></span>' +
            '<div class="ev-buy__body">' +
              '<div class="ev-buy__top">' +
                '<div class="ev-buy__left">' +
                  '<div class="ev-buy__name">One-time purchase</div>' +
                  '<div class="ev-buy__per" data-ev="oncePer"></div>' +
                '</div>' +
                '<div class="ev-buy__price">' +
                  '<b data-ev="onceNow"></b>' +
                  '<div class="ev-buy__you ev-buy__you--muted">No commitment</div>' +
                '</div>' +
              '</div>' +
              '<div class="ev-buy__fold">' +
                '<p class="ev-buy__policy">Try it once, no subscription. Same jar, same 30-day guarantee — and nothing auto-renews.</p>' +
              '</div>' +
            '</div>' +
          '</div>' +

        '</div>' +
      '</div>'
    );

    container.parentNode.insertBefore(panel, container.nextSibling);
    panel.querySelector('[data-ev="perks"]').innerHTML = PERKS.map(function (p) {
      return '<div>' + p[0] + '<span>' + p[1] + '</span></div>';
    }).join('');
    return panel;
  }

  function renderPanel(r, mode, variant) {
    var panel = buildPanel(r);
    if (!panel || !variant) return;
    var q = function (n) { return panel.querySelector('[data-ev="' + n + '"]'); };
    var set = function (n, v) { var e = q(n); if (e && e.textContent !== v) e.textContent = v; };

    if (!isNaN(variant.otp) && variant.servings) {
      set('oncePer', money(variant.otp / variant.servings) + ' / serving');
      set('onceNow', money(variant.otp));
      set('subWas', money(variant.otp));
    }
    if (!isNaN(variant.sub) && variant.servings) {
      set('subPer', money(variant.sub / variant.servings) + ' / serving');
      set('subNow', money(variant.sub));
    }
    if (!isNaN(variant.otp) && !isNaN(variant.sub)) {
      set('subSave', money(variant.otp - variant.sub));
    }

    // частоты доставки — из скрытых радиокнопок приложения
    var block = visibleSubBlock(r);
    var cad = q('cad');
    if (block && cad) {
      var plans = [].slice.call(block.querySelectorAll('.group_list input[type="radio"]'));
      var wanted = plans.map(function (i) { return planLabel(i); }).join('|');
      if (cad.dataset.plans !== wanted) {
        cad.dataset.plans = wanted;
        cad.innerHTML = '';
        plans.forEach(function (input, i) {
          var b = el('<button type="button" class="ev-buy__cadbtn"></button>');
          b.textContent = planLabel(input);
          b.dataset.idx = String(i);
          cad.appendChild(b);
        });
      }
      var checkedIdx = -1;
      plans.forEach(function (input, i) { if (input.checked) checkedIdx = i; });
      [].forEach.call(cad.children, function (b, i) {
        b.classList.toggle('is-on', i === checkedIdx);
        b.setAttribute('aria-pressed', i === checkedIdx ? 'true' : 'false');
      });
    }

    var opts = panel.querySelectorAll('.ev-buy__opt');
    [].forEach.call(opts, function (o) {
      var on = o.dataset.mode === mode;
      o.classList.toggle('is-on', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  /* ---------- строка доверия и кнопка ---------- */
  function addTrust(r) {
    if (r.querySelector('.ev-pdp__trust')) return;
    var buttons = r.querySelector('.product-form-buttons');
    if (!buttons) return;
    var box = el('<div class="ev-pdp__trust"></div>');
    box.innerHTML = TRUST.map(function (t) {
      return '<div>' + t[0] + '<span>' + t[1] + '</span></div>';
    }).join('');
    buttons.parentNode.insertBefore(box, buttons.nextSibling);
  }

  function syncCta(mode, variant) {
    if (!variant || isNaN(variant.otp)) return;
    var value = mode === 'sub' && !isNaN(variant.sub) ? variant.sub : variant.otp;
    var text = money(value);
    var nodes = document.querySelectorAll('.add-to-cart-text__price, .sticky-add-to-cart__button-price');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent.trim() !== text) nodes[i].textContent = text;
    }
    // «Add to Bag -» → «Add to cart —», как в макете
    var labels = document.querySelectorAll('.add-to-cart-text__content');
    for (var j = 0; j < labels.length; j++) {
      var walker = document.createTreeWalker(labels[j], NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var t = node.textContent.trim();
        if (t === 'Add to Bag') node.textContent = 'Add to cart';
        if (t === '-' || t === '—') node.textContent = '\u00A0—';
      }
    }
  }

  /* ---------- состояние приложения подписок ---------- */
  function currentMode(r) {
    var block = visibleSubBlock(r);
    if (!block) return 'once';
    var once = block.querySelector('input[id*="one_time_purchase"]');
    if (once) return once.checked ? 'once' : 'sub';
    var radios = block.querySelectorAll('.tab_radio');
    return radios[1] && radios[1].checked ? 'sub' : 'once';
  }

  function sellingPlanValue() {
    var input = document.querySelector('.product-details input[name="selling_plan"]');
    return input ? input.value : '';
  }

  /* Банки хватает ровно на столько дней, сколько в ней порций: по умолчанию
     предлагаем самую редкую доставку, которая ещё не оставит человека без продукта. */
  function defaultPlan(block, servings) {
    var plans = [].slice.call(block.querySelectorAll('.group_list input[type="radio"]'));
    if (!plans.length) return null;
    if (!servings) return plans[0];
    var best = null, bestDays = -1, fallback = null, fallbackDays = Infinity;
    plans.forEach(function (input) {
      var days = planDays(input);
      if (days && days <= servings && days > bestDays) { best = input; bestDays = days; }
      if (days && days < fallbackDays) { fallback = input; fallbackDays = days; }
    });
    return best || fallback || plans[0];
  }

  function selectSubscription(r) {
    var block = visibleSubBlock(r);
    if (!block) return;
    var radios = block.querySelectorAll('.tab_radio');
    if (!radios[1]) return;
    // скрипт приложения поднимается позже нашего, поэтому клик по уже отмеченной
    // радиокнопке ничего не даёт: снимаем отметку и кликаем заново
    if (radios[0]) radios[0].checked = true;
    radios[1].click();

    var servings = 0;
    var checked = r.querySelector('.variant-option__button-label input:checked');
    if (checked) {
      var textNode = checked.parentElement.querySelector('.variant-option__button-label__text');
      servings = parseInt((textNode ? textNode.textContent : '').trim(), 10) || 0;
    }
    var plan = defaultPlan(block, servings);
    if (plan && !plan.disabled && !plan.checked) plan.click();
  }

  /* Известная проблема приложения: возврат на «One-time purchase» переключает
     вкладку, но не снимает выбранный план — в корзину уходит подписка. Добиваем. */
  function selectOneTime(r) {
    var block = visibleSubBlock(r);
    if (!block) return;
    var radios = block.querySelectorAll('.tab_radio');
    if (radios[0] && !radios[0].checked) radios[0].click();
    var once = block.querySelector('input[id*="one_time_purchase"]');
    if (once && !once.checked) {
      once.checked = true;
      once.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var plans = document.querySelectorAll('input[name="selling_plan"]');
    for (var i = 0; i < plans.length; i++) {
      if (plans[i].value) {
        plans[i].value = '';
        plans[i].dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function ensureSubDefault(r) {
    if (!SUB_DEFAULT || subDefaultDone || userPickedOnce) return;
    selectSubscription(r);
    if (sellingPlanValue()) {
      subDefaultDone = true;
      scheduleLate();
      return;
    }
    if (++subTries >= 40) {
      subDefaultDone = true;
      selectOneTime(r);
      schedule();
      return;
    }
    setTimeout(function () {
      var rr = root();
      if (rr) { ensureSubDefault(rr); schedule(); }
    }, 300);
  }

  /* ---------- главный проход ---------- */
  function sync() {
    var r = root();
    if (!r) return;
    var variants = readVariants(r);
    if (!variants.length) return;

    addSizeMeta(r, variants);
    addTrust(r);

    if (SUB_DEFAULT && !subDefaultDone && !userPickedOnce && currentMode(r) === 'once') {
      ensureSubDefault(r);
    }

    var mode = currentMode(r);
    var variant = currentVariant(variants);
    renderPanel(r, mode, variant);
    syncCta(mode, variant);
    r.classList.add('ev-buy-ready');
  }

  var pending = null, observer = null, target = null;

  function schedule() {
    if (pending) return;
    // setTimeout, а не requestAnimationFrame: во вкладке в фоне rAF не выполняется
    pending = setTimeout(function () {
      pending = null;
      if (observer) observer.disconnect();
      try { sync(); }
      finally { if (observer && target) observer.observe(target, { childList: true, subtree: true }); }
    }, 0);
  }

  function scheduleLate() {
    setTimeout(schedule, 400);
    setTimeout(schedule, 1200);
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('.product-details')) return;
    scheduleLate();
    // при смене размера приложение сбрасывает выбор на разовую покупку —
    // возвращаем подписку, если человек сам её не отменял
    if (e.target.closest('.variant-option__button-label') && !userPickedOnce) {
      subDefaultDone = false;
      subTries = 0;
    }
    schedule();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var r = root();
    if (!r) return;

    var cadBtn = e.target.closest('.ev-buy__cadbtn');
    if (cadBtn) {
      e.preventDefault();
      e.stopPropagation();
      var block = visibleSubBlock(r);
      var plans = block ? block.querySelectorAll('.group_list input[type="radio"]') : [];
      var idx = parseInt(cadBtn.dataset.idx, 10);
      if (plans[idx] && !plans[idx].disabled) plans[idx].click();
      scheduleLate();
      schedule();
      return;
    }

    var opt = e.target.closest('.ev-buy__opt');
    if (opt) {
      e.preventDefault();
      if (opt.dataset.mode === 'sub') {
        userPickedOnce = false;
        subDefaultDone = false;
        subTries = 0;
        ensureSubDefault(r);
      } else {
        userPickedOnce = true;
        subDefaultDone = true;
        selectOneTime(r);
      }
      scheduleLate();
      schedule();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Enter') return;
    var opt = e.target.closest && e.target.closest('.ev-buy__opt');
    if (!opt) return;
    e.preventDefault();
    opt.click();
  });

  function observe() {
    target = document.querySelector('.product-information__grid');
    if (!target) return;
    observer = new MutationObserver(schedule);
    observer.observe(target, { childList: true, subtree: true });
  }

  function start() { sync(); observe(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
